<template>
  <el-card>
    <div style="margin-bottom:16px;">
      <el-button type="primary" @click="openCreate">新增项目</el-button>
    </div>
    <el-table :data="rows" border>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column label="图标" width="80">
        <template slot-scope="scope">
          <img v-if="scope.row.icon" :src="scope.row.icon" style="width:40px;height:40px;object-fit:cover;border-radius:4px;" />
          <span v-else style="color:#999;">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="projectId" label="项目标识" width="150" />
      <el-table-column prop="name" label="项目名称" width="150" />
      <el-table-column prop="subtitle" label="副标题" />
      <el-table-column prop="type" label="类型" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 'internal'" type="success">内部</el-tag>
          <el-tag v-else type="warning">外链</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sortOrder" label="排序" width="80" />
      <el-table-column label="启用" width="80">
        <template slot-scope="scope">{{ scope.row.isActive ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="visible" :title="form.id ? '编辑项目' : '新增项目'" width="800px">
      <el-form :model="form" label-width="140px">
        <el-form-item label="项目标识">
          <el-input v-model="form.projectId" placeholder="如：apple-snail" />
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="form.name" placeholder="如：福寿螺" />
        </el-form-item>
        <el-form-item label="副标题">
          <el-input v-model="form.subtitle" placeholder="如：城市河道与湿地水边重点监测" />
        </el-form-item>
        <el-form-item label="学名">
          <el-input v-model="form.scientificName" placeholder="如：Pomacea canaliculata" />
        </el-form-item>
        <el-form-item label="项目类型">
          <el-radio-group v-model="form.type">
            <el-radio label="internal">内部系统</el-radio>
            <el-radio label="external">跳转第三方</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="项目图标">
          <el-upload
            action="/api/file/upload"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleIconSuccess"
            :before-upload="beforeIconUpload"
            accept="image/*"
          >
            <el-button size="small" type="primary">上传图标</el-button>
          </el-upload>
          <div v-if="form.icon" style="margin-top:10px;">
            <img :src="form.icon" style="max-width:100px;max-height:100px;border:1px solid #ddd;border-radius:4px;" />
            <el-button size="mini" type="text" @click="form.icon=''">删除</el-button>
          </div>
          <div style="color:#999;font-size:12px;margin-top:5px;">建议尺寸：200x200px，支持jpg/png格式</div>
        </el-form-item>
        <el-form-item label="主题色">
          <el-input v-model="form.accent" placeholder="如：#D86D3A" style="width:150px;" />
        </el-form-item>
        <el-form-item v-if="form.type === 'external'" label="第三方小程序AppID">
          <el-input v-model="form.externalAppId" placeholder="如：wx1234567890abcdef" />
        </el-form-item>
        <el-form-item v-if="form.type === 'external'" label="第三方跳转路径">
          <el-input v-model="form.externalPath" placeholder="如：pages/index/index" />
        </el-form-item>
        <el-form-item v-if="form.type === 'internal'" label="识别要点JSON">
          <el-input v-model="form.identification" type="textarea" :rows="3" placeholder='如：["常见于河道、沟渠、稻田等水域边缘"]' />
        </el-form-item>
        <el-form-item v-if="form.type === 'internal'" label="科普配置JSON">
          <el-input v-model="form.scienceConfig" type="textarea" :rows="3" placeholder="JSON格式的科普配置" />
        </el-form-item>
        <el-form-item v-if="form.type === 'internal'" label="数量单位选项JSON">
          <el-input v-model="form.abundanceUnitOptions" type="textarea" :rows="2" placeholder='如：[{"value":"个体","label":"个体数"}]' />
        </el-form-item>
        <el-form-item v-if="form.type === 'internal'" label="默认数量单位">
          <el-input v-model="form.abundanceUnitDefault" placeholder="如：个体" />
        </el-form-item>
        <el-form-item v-if="form.type === 'internal'" label="数量提示文案">
          <el-input v-model="form.abundanceHint" placeholder="如：请填写您观察到的数量" />
        </el-form-item>
        <el-form-item v-if="form.type === 'internal'" label="AI提示语">
          <el-input v-model="form.aiPrompt" type="textarea" :rows="4" placeholder="用于该项目图片识别的AI提示语" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortOrder" :min="0" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.isActive" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { getAdminProjectList, createProject, updateProject, deleteProject } from '@/api'

export default {
  data () {
    return {
      rows: [],
      visible: false,
      form: {},
      uploadHeaders: {
        Authorization: `Bearer ${localStorage.getItem('admin_token')}`
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      const res = await getAdminProjectList()
      this.rows = res.data || []
    },
    openCreate () {
      this.form = {
        projectId: '',
        name: '',
        subtitle: '',
        scientificName: '',
        type: 'internal',
        icon: '',
        accent: '',
        mapCenterLat: null,
        mapCenterLng: null,
        externalAppId: '',
        externalPath: '',
        identification: '',
        scienceConfig: '',
        abundanceUnitOptions: '',
        abundanceUnitDefault: '',
        abundanceHint: '',
        aiPrompt: '',
        sortOrder: 0,
        isActive: 1
      }
      this.visible = true
    },
    edit (row) {
      this.form = { ...row }
      this.visible = true
    },
    beforeIconUpload (file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB')
        return false
      }
      return true
    },
    handleIconSuccess (response) {
      if (response.code === 0 && response.data && response.data.url) {
        this.form.icon = response.data.url
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.message || '上传失败')
      }
    },
    async submit () {
      try {
        const dto = {
          projectId: this.form.projectId,
          name: this.form.name,
          subtitle: this.form.subtitle,
          scientificName: this.form.scientificName,
          type: this.form.type,
          icon: this.form.icon,
          accent: this.form.accent,
          mapCenterLat: this.form.mapCenterLat,
          mapCenterLng: this.form.mapCenterLng,
          externalAppId: this.form.externalAppId,
          externalPath: this.form.externalPath,
          identification: this.form.identification,
          scienceConfig: this.form.scienceConfig,
          abundanceUnitOptions: this.form.abundanceUnitOptions,
          abundanceUnitDefault: this.form.abundanceUnitDefault,
          abundanceHint: this.form.abundanceHint,
          aiPrompt: this.form.aiPrompt,
          sortOrder: this.form.sortOrder,
          isActive: this.form.isActive
        }
        if (this.form.id) {
          await updateProject(this.form.id, dto)
          this.$message.success('更新成功')
        } else {
          await createProject(dto)
          this.$message.success('创建成功')
        }
        this.visible = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },
    async remove (row) {
      try {
        await this.$confirm('确认删除该项目？', '提示', { type: 'warning' })
        await deleteProject(row.id)
        this.$message.success('已删除')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '删除失败')
        }
      }
    }
  }
}
</script>
